import { render, staticRenderFns } from "./Statscore.vue?vue&type=template&id=3a0f4c27&scoped=true&"
import script from "./Statscore.vue?vue&type=script&lang=js&"
export * from "./Statscore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0f4c27",
  null
  
)

export default component.exports